import type * as Types from 'app/types/graphql';

import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { VariantSelectFragmentDoc } from '../fragments/variant.generated';
import { appFetcher } from '~/api/utils/gatewayClient';
export type VariantUpdateMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  input: Types.UpdateVariantInput;
}>;

export type VariantUpdateMutationResponse = {
  variantUpdate?: Types.Maybe<
    Pick<
      Types.Variant,
      | 'id'
      | 'isOrigin'
      | 'isWinner'
      | 'trafficRate'
      | 'themePageID'
      | 'templateType'
      | 'templateSuffix'
      | 'createdAt'
      | 'deletedAt'
      | 'updatedAt'
      | 'winnerTemplateSuffix'
    >
  >;
};

export const VariantUpdateDocument = `
    mutation VariantUpdate($id: ID!, $input: UpdateVariantInput!) {
  variantUpdate(id: $id, input: $input) {
    ...VariantSelect
  }
}
    ${VariantSelectFragmentDoc}`;

export const useVariantUpdateMutation = <TError = unknown, TContext = unknown>(
  options?: UseMutationOptions<
    VariantUpdateMutationResponse,
    TError,
    VariantUpdateMutationVariables,
    TContext
  >,
) => {
  return useMutation<
    VariantUpdateMutationResponse,
    TError,
    VariantUpdateMutationVariables,
    TContext
  >(
    ['VariantUpdate'],
    (variables?: VariantUpdateMutationVariables) =>
      appFetcher<VariantUpdateMutationResponse, VariantUpdateMutationVariables>(
        VariantUpdateDocument,
        variables,
      )(),
    options,
  );
};

useVariantUpdateMutation.getKey = () => ['VariantUpdate'];
